import React from 'react';

import SelectField from '../formik/SelectField';
import TextAreaField from '../formik/TextAreaField';
import TextField from '../formik/TextField';

const getInputField = (fieldDefinition, formikProps) => {
  switch (fieldDefinition.type) {
    
    case 'Date':
      return <TextField
        {...fieldDefinition}
        {...formikProps}
        as="date" />;

    case 'Decimal':
      return <TextField
        {...fieldDefinition}
        {...formikProps}
        type="number"
        step="any" />;

    case 'Integer':
      return <TextField
        {...fieldDefinition}
        {...formikProps}
        type="number"
        step="1" />;

    case 'Text':
      return fieldDefinition.as && fieldDefinition.as === "textarea" ?
        <TextAreaField {...fieldDefinition} {...formikProps} /> :
        <TextField {...fieldDefinition} {...formikProps} />;

    case 'DropDown':
        return <SelectField {...fieldDefinition} {...formikProps} />

    case 'Display':
      const displayTextWithLineBreaks = fieldDefinition.displayText.replace(/\n/g, '<br>');
      return <div dangerouslySetInnerHTML={{ __html: displayTextWithLineBreaks }} />;

    default:
      return null;
  }
}

export default getInputField;
